import { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { useTheme } from '../theme';

/**
 * Hook to create themed styles based on current theme mode
 * @param {Function} createStyles - Function that receives theme object and returns styles
 * @returns {Object} StyleSheet object with themed styles
 */
export const useThemedStyles = (createStyles) => {
	const { mode, theme } = useTheme();

	return useMemo(() => {
		const styles = createStyles(theme, mode);
		return StyleSheet.create(styles);
	}, [mode, theme, createStyles]);
};

export default useThemedStyles;
